import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "mystudio_cookie_consent";

const CookieConsent = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setOpen(true);
    } catch {
      setOpen(true);
    }
    const onOpen = () => setOpen(true);
    window.addEventListener("mystudio:open-cookie-consent", onOpen);
    return () => window.removeEventListener("mystudio:open-cookie-consent", onOpen);
  }, []);

  const save = (value: "accepted" | "declined") => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ value, ts: Date.now() }));
    } catch {}
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className="fixed bottom-0 inset-x-0 z-50 bg-surface border-t border-border shadow-lg"
    >
      <div className="container mx-auto px-4 lg:px-8 py-4 flex flex-col md:flex-row items-start md:items-center gap-4 justify-between">
        <p className="text-xs md:text-sm text-muted-foreground font-body max-w-2xl">
          We use cookies for essential site functions, analytics (Google Analytics), and advertising (Meta Pixel). See our{" "}
          <Link to="/cookie-policy" className="text-primary hover:underline">Cookie Policy</Link> and{" "}
          <Link to="/privacy-policy" className="text-primary hover:underline">Privacy Policy</Link>.
        </p>
        <div className="flex items-center gap-2 shrink-0">
          <button
            onClick={() => save("declined")}
            className="border border-border text-foreground px-4 py-2 font-display tracking-[0.15em] text-[10px] hover:bg-background transition-colors"
          >
            DECLINE
          </button>
          <button
            onClick={() => save("accepted")}
            className="bg-primary text-primary-foreground px-4 py-2 font-display tracking-[0.15em] text-[10px] hover:bg-primary/90 transition-colors"
          >
            ACCEPT
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;